/* Selected finish examples only. Upload, crop, pricing and cart logic remain in the existing editor. */
(() => {
  if (customElements.get('atelier-finish-preview')) return;
  customElements.define('atelier-finish-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.config = JSON.parse(this.querySelector('[data-finish-config]').textContent);
      this.form = this.closest('form');
      this.dialog = this.querySelector('dialog');
      this.opener = this.querySelector('[data-finish-open]');
      this.form?.addEventListener('change', event => {
        if (event.target.matches('input[name="mag-finish"]')) this.update();
      }, { signal });
      this.opener.addEventListener('click', () => {
        const sample = this.currentSample();
        if (!sample || sample.classic) return;
        this.paint(this.querySelector('[data-finish-dialog-visual]'), sample, true);
        this.querySelector('[data-finish-dialog-title]').textContent = this.heading(sample);
        this.querySelector('[data-finish-dialog-note]').textContent = this.note(sample);
        this.dialog.showModal();
      }, { signal });
      this.querySelector('[data-finish-close]').addEventListener('click', () => this.dialog.close(), { signal });
      this.dialog.addEventListener('close', () => this.opener.focus({ preventScroll: true }), { signal });
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      }, { signal });
      // The original editor sets its initial checked variant synchronously after cloning its template.
      queueMicrotask(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
    }
    currentSample() {
      const selected = this.form?.querySelector('input[name="mag-finish"]:checked')?.value;
      return this.config.finishes.find(sample => sample.value === selected);
    }
    heading(sample) {
      return sample.classic ? this.config.classicHeading : `${this.config.film} · ${sample.title}`;
    }
    note(sample) { return sample.classic ? this.config.classicNote : this.config.note; }
    paint(visual, sample, large = false) {
      visual.classList.toggle('atelier-finish-preview__visual--atlas', sample.atlas);
      visual.style.setProperty('--finish-x', String(sample.position % 2));
      visual.style.setProperty('--finish-y', String(Math.floor(sample.position / 2)));
      const image = visual.querySelector('img');
      image.src = large ? sample.full : sample.src;
      image.alt = sample.classic ? this.config.productAlt : this.config.alt.replace('__finish__', sample.title);
    }
    update() {
      const sample = this.currentSample();
      this.hidden = !sample || sample.classic;
      this.dataset.selectedFinish = sample?.value || '';
      if (this.hidden) {
        for (const image of this.querySelectorAll('img')) image.removeAttribute('src');
        if (this.dialog.open) this.dialog.close();
        return;
      }
      this.paint(this.querySelector('[data-finish-visual]'), sample);
      this.querySelector('[data-finish-title]').textContent = this.heading(sample);
      this.querySelector('[data-finish-note]').textContent = this.note(sample);
      this.opener.setAttribute('aria-label', this.config.openLabel.replace('__finish__', sample.title));
      this.dataset.selectedFinish = sample.value;
    }
  });
})();
